import { DistanceRateConfig } from "../DistanceRateConfig";
import { Button, DataSource, HorizontalSpacer, Label, Layout, Panel, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutDistanceCalculatorOverview extends Layout {
    buttonExpandPracticalConfig: Button;
    buttonExpandShortConfig: Button;
    horizontalspacerPracticalProfile: HorizontalSpacer;
    horizontalspacerShortProfile: HorizontalSpacer;
    labelCongifurePracticalProfile: Label;
    labelCongifureShortProfile: Label;
    labelMilesHeaderPractical: Label;
    labelMilesHeaderShort: Label;
    labelPracticalMilesCalculateValue: Label;
    labelPracticalTollAmntCalculateValue: Label;
    labelShortMilesCalculateValue: Label;
    labelShortTollAmntCalculateValue: Label;
    labelTollAmountHeaderPractical: Label;
    labelTollAmountHeaderShort: Label;
    layoutPracticalDistanceRateConfig: DistanceRateConfig;
    layoutShortDistanceRateConfig: DistanceRateConfig;
    mainPanelPracticalDistance: Panel;
    mainPanelShortDistance: Panel;
    panelOverviewSummary: Panel;
    panelPracticalDistance: Panel;
    panelProfile1Config: Panel;
    panelProfile2Config: Panel;
    panelShortDistance: Panel;
    sourceDistanceControl: DataSource;
    sourceDistanceSource: DataSource;
    textboxPracticalProfile: Textbox;
    textboxShortDistProfile: Textbox;
}
